/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationUseDate
 */
export interface JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationUseDate {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationUseDate
     */
    useScheduleDateTime?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationUseDate
     */
    subsidyPriceId?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationUseDate
     */
    price?: number;
}

export function JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationUseDateFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationUseDate {
    return JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationUseDateFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationUseDateFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationUseDate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'useScheduleDateTime': !exists(json, 'useScheduleDateTime') ? undefined : json['useScheduleDateTime'],
        'subsidyPriceId': !exists(json, 'subsidyPriceId') ? undefined : json['subsidyPriceId'],
        'price': !exists(json, 'price') ? undefined : json['price'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationUseDateToJSON(value?: JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationUseDate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'useScheduleDateTime': value.useScheduleDateTime,
        'subsidyPriceId': value.subsidyPriceId,
        'price': value.price,
    };
}

